import { useEffect, useState } from "react";

/**
 * Live "OPEN 24/7" badge — pulsing dot + Brussels time clock.
 * SSR-safe: renders a stable label until client hydration.
 */
export function LiveBadge({ compact = false }: { compact?: boolean }) {
  const [time, setTime] = useState<string>("--:--");

  useEffect(() => {
    const fmt = () =>
      new Intl.DateTimeFormat("en-GB", {
        timeZone: "Europe/Brussels",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      }).format(new Date());
    setTime(fmt());
    const id = window.setInterval(() => setTime(fmt()), 30_000);
    return () => window.clearInterval(id);
  }, []);

  if (compact) {
    return (
      <span className="inline-flex items-center gap-2 font-mono text-[10px] font-semibold uppercase tracking-[0.18em] text-foreground/70">
        <span className="tick-dot" aria-hidden /> Open · {time}
      </span>
    );
  }

  return (
    <span className="inline-flex items-center gap-3 border-[1.5px] border-foreground bg-background px-3 py-1.5 font-mono text-[11px] font-bold uppercase tracking-[0.18em] text-foreground">
      <span className="tick-dot" aria-hidden />
      Brussels {time}
    </span>
  );
}
